import React, { useState } from "react";
import "./reminder.scss";
import { useNavigate } from "react-router-dom";
function ReminderModel({ closeModel }: any) {
  const navigate = useNavigate();
  return (
    <div className="payment_reminder">
      <div className="container_rem">
        <div>
          <h2>Payment Reminder </h2>
          <p> Dear User, </p>
          <p>
            We hope you're enjoying our software! To continue using all the
            features and benefits, please kindly proceed with your payment at
            your earliest convenience.
          </p>
          <p> Thank you for your prompt attention to this matter.</p>
          <p> Best regards, </p>
          <p> Care32 Dent Software</p>
          <div className="rem_btn">
            <button onClick={() => closeModel()}>OK</button>
            <button onClick={() => navigate("/pay")}>Pay now</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderModel;
